import { createContext } from "react"
import type { MediaPreviewOptions } from "@love-irish/resource-media-previews"

/**
 * When a list/section opts in (via ResourceListItem's `preview` prop), BaseListItem renders the resource's
 * rich media preview (record & sleeve, book, cover — @love-irish/resource-media-previews) in place of the
 * plain thumbnail, using the resolved options here. Null = the normal card thumbnail. A context so we don't
 * thread the option through every per-type item's `media` prop.
 */
export const MediaPreviewContext = createContext<MediaPreviewOptions | null>(null)
